"use client"

import { useState } from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { CreateAdmin } from "./create-admin"
import { useAuth } from "@/context/AuthContext"
import { UserManagementDashboard } from "./user-management"
import { CreateUser } from "../user/create-user"
import { TransactionHistory } from "./transaction-history"
import { CreateResults } from "./create-results"
import { DeclareResults } from "./declare-results"
import SessionsPage from "./session-page"
import { BookingManagement } from "./booking-management"

export function AdminDashboard() {
  const { user: currentUser } = useAuth()
  const [refreshKey, setRefreshKey] = useState(0)

  const handleUserCreated = () => {
    setRefreshKey(prev => prev + 1) // Trigger refresh of user list
  }
  const handleSessionCreated = () => {
    setRefreshKey(prev => prev + 1)
  }
  return (
    <div className="space-y-6 p-12">
      <div>
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
        <p className="text-muted-foreground">
          Welcome, {currentUser?.userId} ({currentUser?.role}) ({currentUser?.referralCode})
        </p>
      </div>

      <Tabs defaultValue="users" className="space-y-4">
      <TabsList>
  <TabsTrigger value="users">User Management</TabsTrigger>
  <TabsTrigger value="bookings">Booking Management</TabsTrigger> {/* Add this */}
  <TabsTrigger value="create">Create Users</TabsTrigger>
  {currentUser?.role === 'ADMIN' && (
    <TabsTrigger value="create-admin">Create Admin</TabsTrigger>
  )}
  <TabsTrigger value="transactions">Transactions</TabsTrigger>
  {currentUser?.role === 'ADMIN' && (
    <>
      <TabsTrigger value="create-result">Create Result</TabsTrigger>
      <TabsTrigger value="sessions">Sessions</TabsTrigger>
      <TabsTrigger value="declare-results">Declare Results</TabsTrigger>
    </>
  )}
</TabsList>

        <TabsContent value="users" className="space-y-4">
          <UserManagementDashboard key={refreshKey} />
        </TabsContent>

<TabsContent value="bookings" className="space-y-4">
  <BookingManagement />
</TabsContent>
        <TabsContent value="create" className="space-y-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <CreateUser onUserCreated={handleUserCreated} />
            <div className="space-y-4">
              <h3 className="text-lg font-semibold">Role Hierarchy</h3>
              <div className="space-y-2 text-sm">
                <div className="p-3 border rounded-lg">
                  <strong>Admin</strong> → Can create Distributors, Agents, and Customers
                </div>
                <div className="p-3 border rounded-lg">
                  <strong>Distributor</strong> → Can create Agents and Customers
                </div>
                <div className="p-3 border rounded-lg">
                  <strong>Agent</strong> → Can create Customers
                </div>
                <div className="p-3 border rounded-lg">
                  <strong>Customer</strong> → Can play lottery games
                </div>
              </div>
            </div>
          </div>
        </TabsContent>

        {currentUser?.role === 'ADMIN' && (
          <>
          <TabsContent value="sessions" className="space-y-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <SessionsPage/>
          </div>
        </TabsContent>

        <TabsContent value="declare-results" className="space-y-4">
          <DeclareResults />
        </TabsContent>
          <TabsContent value="create-admin" className="space-y-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <CreateAdmin />
              <div className="space-y-4">
                <h3 className="text-lg font-semibold">About Admin Accounts</h3>
                <div className="space-y-2 text-sm text-muted-foreground">
                  <p>• Admin accounts have full system access</p>
                  <p>• Only existing admins can create new admin accounts</p>
                  <p>• Admins can create distributors who can then create agents</p>
                  <p>• Admins receive commission reports from all levels</p>
                  <p>• Keep admin credentials secure</p>
                </div>
              </div>
            </div>
          </TabsContent></>
        )}

        <TabsContent value="transactions" className="space-y-4">
          <TransactionHistory />
        </TabsContent>
<TabsContent value="create-result" className="space-y-4">
  <CreateResults />
</TabsContent>
      </Tabs>
    </div>
  )
}





